import React from 'react';

export default function CustomFooter() {
  return (
    <footer className="footer">
      <div className="page-container">
        SitsCom &copy; {new Date().getFullYear()} &mdash; Built by{' '}
        <a href="https://github.com/MuhammadSaboorIslam" target="_blank" rel="noreferrer">
          Muhammad Saboor Islam
        </a>{' '}
        &amp;{' '}
        <a href="https://github.com/Asfar224" target="_blank" rel="noreferrer">
          Muhammad Asfar
        </a>
      </div>
    </footer>
  );
}
